import chipStatusColor from './chipStatusColor'
import statusLabel from './statusLabel'

const orders = {
  chipStatusColor,
  statusLabel,
}

export default orders
